import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HVACLayoutGlyph = /*#__PURE__*/createElement("g", {
  id: "hvac_layout"
}, /*#__PURE__*/createElement("path", {
  d: "M31.1 25.2c-.6-.1-1.1.1-1.6.2-.2 0-.4.1-.6.1v.3c.2 0 .3.2.5.2.2.2.5.3.7.6.4.4.7.8 1.1 1.2.2.3.5.7.6 1.1.5 1.2-1.3 3.2-2.5 3.1-1.4-.1-.8-2.1-.5-3.3.1-.7-.1-1.1-.2-1.7 0-.2-.1-.4-.1-.6h-.2c-.1.2-.2.3-.2.5-.1.3-.3.5-.5.7-.3.4-.7.8-1.1 1.1-.3.2-.6.5-1 .7-1.2.5-3-1.4-2.9-2.7.1-1.5 2-.8 3.1-.5.6.1 1.1-.1 1.6-.2.2 0 .4-.1.6-.2v-.2c-.2 0-.4-.2-.5-.2-.2-.2-.5-.4-.7-.6-.4-.4-.7-.8-1-1.2-.2-.3-.5-.7-.6-1.1-.5-1.2 1.3-3.2 2.5-3.1 1.4.1.8 2.1.5 3.3-.1.7.1 1.1.2 1.7 0 .2.1.4.1.6h.3c0-.1.1-.3.2-.4.2-.3.3-.5.5-.7.3-.4.7-.8 1.1-1.1.3-.3.6-.5 1-.7 1.2-.5 3 1.4 2.9 2.6-.4 1.5-2.2.8-3.3.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M42.3 17.2v6.2h-2.7c-1.5 0-2.7 1.2-2.8 2.7-.2 4.5-3.9 8.1-8.5 8.1-4.7 0-8.5-3.8-8.5-8.5s3.8-8.5 8.5-8.5h14m1.7-2.8H28.3c-6.2 0-11.3 5-11.3 11.3C17 31.9 22 37 28.3 37c6.1 0 11-4.8 11.2-10.8H44c.6 0 1.1-.5 1.1-1.1v-9.6c0-.6-.5-1.1-1.1-1.1zM47.2 56.5h18c1 0 1.8-.8 1.8-1.8v-6.1c0-1-.8-1.8-1.8-1.8h-18c-1 0-1.8.8-1.8 1.8v1.5h-16v-8.5h-3v24.6h19v1.5c0 1 .8 1.8 1.8 1.8h18c1 0 1.8-.8 1.8-1.8v-6.1c0-1-.8-1.8-1.8-1.8h-18c-1 0-1.8.8-1.8 1.8v1.5h-16v-10h16v1.5c0 1.1.8 1.9 1.8 1.9zm1.2-6.7h15.5v3.6H48.4v-3.6zm0 13.1h15.5v3.6H48.4v-3.6z"
}));
const HVACLayout = createSvg({
  name: 'hvac_layout',
  path: HVACLayoutGlyph
});

export default HVACLayout;
export { HVACLayoutGlyph };
